import React from 'react'
import { useTable, useExpanded } from 'react-table'

import makeData from './makeData'

import MOCK_DATA from './../CustomerForm/MOCK_DATA.json'


function Table({ columns: userColumns, data, renderRowSubComponent  }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
    state: { expanded },
  } = useTable(
    {
      columns: userColumns,
      data,
    },
    useExpanded // Use the useExpanded plugin hook
  )
console.log(data)
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            console.log(row)
            return (
                           // Use a React.Fragment here so the table markup is still valid
                           <React.Fragment {...row.getRowProps()}>
                           <tr>
                             {row.cells.map(cell => {
                               return (
                                 <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                               )
                             })}
                           </tr>
                           {/*
                               If the row is in an expanded state, render a row with a
                               column that fills the entire length of the table.
                             */}
                           {row.isExpanded ? (
                             <tr>
                               <td colSpan={visibleColumns.length / 2}>
                                 {/*
                                     Inside it, call our renderRowSubComponent function. In reality,
                                     you could pass whatever you want as props to
                                     a component like this, including the entire
                                     table instance. But for this example, we'll just
                                     pass the row
                                   */}
                                 {renderRowSubComponent({ row })}
                               </td>
        {console.log(row.original.phone)}
                               <td><p>{row.values.age}</p></td>
                               <td><p>{row.original.phone}</p></td>
                             </tr>
                           ) : null}
                         </React.Fragment>
            )
          })}
        </tbody>
      </table>
      <br />
      <div>Showing the first 20 results of {rows.length} rows</div>
      <pre>
        <code>{JSON.stringify({ expanded: expanded }, null, 2)}</code>
      </pre>
    </>
  )
}

function NestedTable() {
  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? '👇' : '👉'}
          </span>
        ),
      },
      {
        Header: 'Name',
        columns: [
          {
            Header: 'First Name',
            accessor: 'first_name',
          },
          {
            Header: 'Last Name',
            accessor: 'lastName',
          },
        ],
      },
      {
        Header: 'Info',
        columns: [
          {
            Header: 'Age',
            accessor: 'age',
          },
          {
            Header: 'Visits',
            accessor: 'visits',
          },
          {
            Header: 'Status',
            accessor: 'status',
          },
          {
            Header: 'Profile Progress',
            accessor: 'progress',
          },
        ],
      },
    ],
    []
  )

  const data = React.useMemo(() => MOCK_DATA, [])


    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(
      ({ row }) => (
        <>
        <pre
          style={{
            fontSize: '10px',
          }}
        >
          <code>{JSON.stringify({ values: row.values }, null, 2)}</code>
        </pre>
        </>
       ),
      []
    )


  return (
    
      <Table columns={columns} data={data} renderRowSubComponent={renderRowSubComponent}/>
    
  )
}

export default NestedTable